var map = {
	"./twitter-512x512-index.jpg": "F6mX",
	"./twitter-512x512-people.jpg": "pigF",
	"./twitter-512x512-planet.jpg": "3MCT",
	"./twitter-512x512-privacy.jpg": "v8DZ",
	"./twitter-512x512-products-passionfruit-mango-lip-balm.jpg": "bP3t",
	"./twitter-512x512-products-peach-blossom-lip-balm.jpg": "cWpz",
	"./twitter-512x512-products-peppermint-creme-lip-balm.jpg": "QuyJ",
	"./twitter-512x512-products-strawberry-creme-organic-lip-balm.jpg": "8Mxm",
	"./twitter-512x512-products-vanilla-bean-organic-lip-balm.jpg": "Zagb",
	"./twitter-512x512-products-variety-lip-balm.jpg": "5/PD",
	"./twitter-512x512-products-very-cherry-lip-balm.jpg": "llfN",
	"./twitter-512x512-products.jpg": "4Dlf",
	"./twitter-512x512-purpose.jpg": "8PWh",
	"./twitter-512x512-terms.jpg": "MQM3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "p5WP";